import { createContext, useContext, useEffect, useState } from "react";
import {
  useGetEligibleRedEnvelope,
  usePutRedEnvelope,
} from "../hooks/redEnvelope/redenvelope.hooks";
import { RedEnvelopePopup } from "../pages/Home/components";
import { usePopupContext } from "../pages/Home/context/PopupContext";
import { popupSortingEnum } from "../pages/Home/enumeration/popupSortingEnum";
import { envChangeType, envType } from "../plugins/utils";
import { useLogin } from "./LoginContext";
import { useLoading } from "./modules/LoadingContext";

const RedEnvelopeContext = createContext({
  redEnvelope: undefined,
  setShowRedEnvelopePopup: () => {},
});

export const RedEnvelopeContextProvider = ({ children }) => {
  const timeName = "redEnvelopePopupTime";
  const { sorting, setNextSorting } = usePopupContext();
  const { setIsLoading } = useLoading();
  const [showRedEnvelopePopup, setShowRedEnvelopePopup] = useState(false);
  const [bonusAmount, setBonusAmount] = useState(0);
  const [isApplied, setIsApplied] = useState(false);

  const { isLogin } = useLogin();
  const { data: redEnvelope } = useGetEligibleRedEnvelope({
    enabled: isLogin && envChangeType("REACT_APP_SHOW_RED_ENVELOPE", envType.BOOLEAN) === true,
  });
  const { mutate: applyRedEnvelope } = usePutRedEnvelope({
    onSuccess: (data) => {
      console.debug(data);
      setBonusAmount(data?.bonus_amount);
      setTimeout(() => {
        setIsLoading(false);
        setShowRedEnvelopePopup(true);
        setIsApplied(true);
      }, 500);
    },
    onError: (error) => {
      setIsLoading(false);
      console.debug(JSON.stringify("ERR", error));
    },
  });

  useEffect(() => {
    if (sorting !== popupSortingEnum[timeName].sorting) return;
    if (!envChangeType("REACT_APP_SHOW_RED_ENVELOPE", envType.BOOLEAN)) {
      setNextSorting();
      return;
    }
    if (redEnvelope === undefined) return;
    if (redEnvelope) {
      if (envChangeType("REACT_APP_AUTO_RED_ENVELOPE", envType.BOOLEAN)) {
        setIsLoading(true);
        applyRedEnvelope();
      } else {
        setShowRedEnvelopePopup(true);
      }
    } else {
      setNextSorting();
    }
  }, [redEnvelope, sorting]);

  return (
    <RedEnvelopeContext.Provider value={{ redEnvelope, setShowRedEnvelopePopup }}>
      {children}
      <RedEnvelopePopup
        setNextSorting={setNextSorting}
        bonusAmount={bonusAmount}
        showRedEnvelopePopup={showRedEnvelopePopup}
        setShowRedEnvelopePopup={setShowRedEnvelopePopup}
        applyRedEnvelope={applyRedEnvelope}
        isApplied={isApplied}
      />
    </RedEnvelopeContext.Provider>
  );
};
export const useRedEnvelope = () => {
  const RedEnvelopeValue = useContext(RedEnvelopeContext);
  return RedEnvelopeValue;
};
